//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetFiltersApiSuccess } from './actions';
import { FilterItem } from 'features/Dealers/Performance/Filter/state/types';

export interface PerformanceFiltersState {
    items?: FilterItem[]
}

const defaultState: PerformanceFiltersState = {
    items: undefined
};

type FiltersAction = ActionGetFiltersApiSuccess;

function performancefiltersReducer(state: PerformanceFiltersState = defaultState, action: FiltersAction): PerformanceFiltersState {
    switch (action.type) {
        case ACTIONS.GET_FILTERS_API_SUCCESS:
            {
                return {
                    ...state,
                    items:  action.filtersItems
                }
            }
    }
    return {
        ...state
    }
}

export default performancefiltersReducer;